module.exports = __webpack_public_path__ + "img/logo.220451d1.png";